import './Competension.scss';

import * as Yup from 'yup';

import { Dispatch, SetStateAction } from 'react';
import { FieldArray, Form, Formik } from 'formik';
import { backendURL, debug } from '../../../../App';

import Button from '../../../../components/Button';
import Input from '../../../../components/Input';
import SubTitle from '../../SubTitle';
import TextareaWYSIWYG from '../../../../components/TextareaWYSIWYG';
import axios from 'axios';
import consoleLog from '../../../../helpers/consoleLog';
import icon_closeBlue from '../../../../assets/images/icon_closeBlue.svg';
import icon_plus from '../../../../assets/images/icon_plus.svg';
import { queryCache } from 'react-query';
import useDeleteCompetentionMutation from '../../../../hooks/useDeleteCompetensionMutation';
import { useParams } from 'react-router-dom';

interface Props {
  competensionData?: {
    anketa_id: number;
    description: string;
    id: number;
    rate_model?: number;
    norm_percent?: number;
    recomendation_bad: string; // * HTML as string, DEPRECATED
    recomendation_bad_article: string;
    recomendation_bad_book: string;
    recomendation_bad_video: string;
    recomendation_bad_podcasts: string;
    recomendation_bad_courses: string;
    recomendation_good: string; // * HTML as string, DEPRECATED
    recomendation_good_article: string;
    recomendation_good_book: string;
    recomendation_good_video: string;
    recomendation_good_podcasts: string;
    recomendation_good_courses: string;
    title: string;
    indicators: any;
  };
  isAddCompenetsionButton?: boolean;
  addCompenetsion: Dispatch<SetStateAction<boolean>>;
}

export const Competension: React.FC<Props> = ({ competensionData, isAddCompenetsionButton, addCompenetsion }) => {
  const { anketaID } = useParams<{ anketaID: string }>();

  const [mutate] = useDeleteCompetentionMutation({
    onSuccess: () => {
      queryCache.invalidateQueries(['competensionsData', anketaID]);
    },
  });

  return (
    <div className='compentesion'>
      <Formik
        initialValues={{
          title: competensionData?.title || '',
          norm_percent: competensionData?.norm_percent !== undefined ? competensionData?.norm_percent : 67,
          description: competensionData?.description || '',
          recomendation_good: competensionData?.recomendation_good || '',
          recomendation_good_article: competensionData?.recomendation_good_article || '',
          recomendation_good_book: competensionData?.recomendation_good_book || '',
          recomendation_good_video: competensionData?.recomendation_good_video || '',
          recomendation_good_podcasts: competensionData?.recomendation_good_podcasts || '',
          recomendation_good_courses: competensionData?.recomendation_good_courses || '',
          recomendation_bad: competensionData?.recomendation_bad || '',
          recomendation_bad_article: competensionData?.recomendation_bad_article || '',
          recomendation_bad_book: competensionData?.recomendation_bad_book || '',
          recomendation_bad_video: competensionData?.recomendation_bad_video || '',
          recomendation_bad_podcasts: competensionData?.recomendation_bad_podcasts || '',
          recomendation_bad_courses: competensionData?.recomendation_bad_courses || '',
          indicators: competensionData?.indicators?.length > 0 ? competensionData?.indicators : [{ id: '', title: '', description: '' }],
        }}
        validationSchema={Yup.object({
          title: Yup.string().required('поле должно быть заполнено'),
          norm_percent: Yup.number().min(0).max(100).required('укажите норму в процентах'),
        })}
        onSubmit={async (values, { setSubmitting, setStatus }) => {
          let clientFormData = new FormData();
          Object.entries(values).forEach(([key, value]) => {
            if (key === 'indicators') {
              clientFormData.append(key, JSON.stringify(value));
            } else {
              // @ts-ignore
              clientFormData.append(key, value);
            }
          });
          clientFormData.append('anketa_id', anketaID);
          clientFormData.append('rate_model', String(Math.round((Number(values.norm_percent) * 3) / 100)));

          try {
            const { data } = await axios({
              method: 'post',
              url: competensionData?.id ? `${backendURL}competention/${competensionData?.id}/` : `${backendURL}competentions/`,
              headers: {
                Authorization: `Token ${localStorage.getItem('skillsSurveyUserToken')}`,
              },
              data: clientFormData,
            });
            setSubmitting(false);
            setStatus({ success: true });
            addCompenetsion ? addCompenetsion(false) : console.log();
            queryCache.invalidateQueries(['competensionsData', anketaID]);
            debug && consoleLog('success', 'Comptension save', data);
          } catch (error) {
            setSubmitting(false);
            debug && consoleLog('error', 'Comptension save', error);
          }
        }}
      >
        {props => (
          <Form>
            <div className='competensionFieldsWrapper'>
              <SubTitle>Компетенция</SubTitle>
              <Input
                name='title'
                type='text'
                value={props.values.title}
                onChange={event => props.setFieldValue('title', event.target.value)}
                onBlur={() => props.setFieldTouched('title', true)}
                placeholderType='alwaysVisible'
                placeholder='Наименование компетенции'
                isDisabled={props.isSubmitting === true ? true : false}
                isValid={!(props.errors.title && props.touched.title)}
                validationError={props.errors.title && props.touched.title ? props.errors.title : undefined}
                autoComplete='off'
              />
              <Input
                data-testid='norm-percent-input'
                name='norm_percent'
                type='number'
                min={0}
                max={100}
                value={props.values.norm_percent}
                onChange={event => props.setFieldValue('norm_percent', event.target.value === '' ? '' : Number(event.target.value))}
                onBlur={() => props.setFieldTouched('norm_percent', true)}
                placeholderType='alwaysVisible'
                placeholder='Требуемый уровень компетенции, %'
                isDisabled={props.isSubmitting === true ? true : false}
                isValid={!(props.errors.norm_percent && props.touched.norm_percent)}
                validationError={props.errors.norm_percent && props.touched.norm_percent ? props.errors.norm_percent : undefined}
                autoComplete='off'
              />
              <TextareaWYSIWYG
                value={props.values.description}
                onChange={value => props.setFieldValue('description', value.replace(/(<([^>]+)>)/gi, '') ? value : '')}
                onBlur={() => props.setFieldTouched('description', true)}
                placeholderType='alwaysVisible'
                placeholder='Расшифровка компетенции'
                modulesType='noModules'
              />
            </div>

            <div className='reccomendationsFieldsWrapper'>
              <SubTitle>Рекомендации</SubTitle>
              {/* // * Положительные реомендации  */}
              <TextareaWYSIWYG
                value={props.values.recomendation_good}
                onChange={value => props.setFieldValue('recomendation_good', value.replace(/(<([^>]+)>)/gi, '') ? value : '')}
                onBlur={() => props.setFieldTouched('recomendation_good', true)}
                placeholderType='alwaysVisible'
                placeholder='Положительная рекомендация для участника | общая'
                modulesType='defaultWithLink'
              />
              <TextareaWYSIWYG
                value={props.values.recomendation_good_article}
                onChange={value => props.setFieldValue('recomendation_good_article', value.replace(/(<([^>]+)>)/gi, '') ? value : '')}
                onBlur={() => props.setFieldTouched('recomendation_good_article', true)}
                placeholderType='alwaysVisible'
                placeholder='Положительная рекомендация для участника | статьи'
                modulesType='defaultWithLink'
              />
              <TextareaWYSIWYG
                value={props.values.recomendation_good_book}
                onChange={value => props.setFieldValue('recomendation_good_book', value.replace(/(<([^>]+)>)/gi, '') ? value : '')}
                onBlur={() => props.setFieldTouched('recomendation_good_book', true)}
                placeholderType='alwaysVisible'
                placeholder='Положительная рекомендация для участника | книги'
                modulesType='defaultWithLink'
              />
              <TextareaWYSIWYG
                value={props.values.recomendation_good_video}
                onChange={value => props.setFieldValue('recomendation_good_video', value.replace(/(<([^>]+)>)/gi, '') ? value : '')}
                onBlur={() => props.setFieldTouched('recomendation_good_video', true)}
                placeholderType='alwaysVisible'
                placeholder='Положительная рекомендация для участника | видео'
                modulesType='defaultWithLink'
              />
              <TextareaWYSIWYG
                value={props.values.recomendation_good_courses}
                onChange={value => props.setFieldValue('recomendation_good_courses', value.replace(/(<([^>]+)>)/gi, '') ? value : '')}
                onBlur={() => props.setFieldTouched('recomendation_good_courses', true)}
                placeholderType='alwaysVisible'
                placeholder='Положительная рекомендация для участника | курсы'
                modulesType='defaultWithLink'
              />
              <TextareaWYSIWYG
                value={props.values.recomendation_good_podcasts}
                onChange={value => props.setFieldValue('recomendation_good_podcasts', value.replace(/(<([^>]+)>)/gi, '') ? value : '')}
                onBlur={() => props.setFieldTouched('recomendation_good_podcasts', true)}
                placeholderType='alwaysVisible'
                placeholder='Положительная рекомендация для участника | подкасты'
                modulesType='defaultWithLink'
              />
              {/* // * Отрицательные реомендации  */}
              <TextareaWYSIWYG
                value={props.values.recomendation_bad}
                onChange={value => props.setFieldValue('recomendation_bad', value.replace(/(<([^>]+)>)/gi, '') ? value : '')}
                onBlur={() => props.setFieldTouched('recomendation_bad', true)}
                placeholderType='alwaysVisible'
                placeholder='Отрицательная рекомендация для участника | общая'
                modulesType='defaultWithLink'
              />
              <TextareaWYSIWYG
                value={props.values.recomendation_bad_article}
                onChange={value => props.setFieldValue('recomendation_bad_article', value.replace(/(<([^>]+)>)/gi, '') ? value : '')}
                onBlur={() => props.setFieldTouched('recomendation_bad_article', true)}
                placeholderType='alwaysVisible'
                placeholder='Отрицательная рекомендация для участника | статьи'
                modulesType='defaultWithLink'
              />
              <TextareaWYSIWYG
                value={props.values.recomendation_bad_book}
                onChange={value => props.setFieldValue('recomendation_bad_book', value.replace(/(<([^>]+)>)/gi, '') ? value : '')}
                onBlur={() => props.setFieldTouched('recomendation_bad_book', true)}
                placeholderType='alwaysVisible'
                placeholder='Отрицательная рекомендация для участника | книги'
                modulesType='defaultWithLink'
              />
              <TextareaWYSIWYG
                value={props.values.recomendation_bad_video}
                onChange={value => props.setFieldValue('recomendation_bad_video', value.replace(/(<([^>]+)>)/gi, '') ? value : '')}
                onBlur={() => props.setFieldTouched('recomendation_bad_video', true)}
                placeholderType='alwaysVisible'
                placeholder='Отрицательная рекомендация для участника | видео'
                modulesType='defaultWithLink'
              />
              <TextareaWYSIWYG
                value={props.values.recomendation_bad_courses}
                onChange={value => props.setFieldValue('recomendation_bad_courses', value.replace(/(<([^>]+)>)/gi, '') ? value : '')}
                onBlur={() => props.setFieldTouched('recomendation_bad_courses', true)}
                placeholderType='alwaysVisible'
                placeholder='Отрицательная рекомендация для участника | курсы'
                modulesType='defaultWithLink'
              />
              <TextareaWYSIWYG
                value={props.values.recomendation_bad_podcasts}
                onChange={value => props.setFieldValue('recomendation_bad_podcasts', value.replace(/(<([^>]+)>)/gi, '') ? value : '')}
                onBlur={() => props.setFieldTouched('recomendation_bad_podcasts', true)}
                placeholderType='alwaysVisible'
                placeholder='Отрицательная рекомендация для участника | подкасты'
                modulesType='defaultWithLink'
              />
            </div>

            <div className='indicatorsFieldsWrapper'>
              <SubTitle>Индикаторы</SubTitle>
              <FieldArray name='indicators'>
                {({ push, remove }) =>
                  props.values.indicators.map((_, index) => (
                    <div className='indicator'>
                      <div className='indicatorWrapper'>
                        <Input
                          name={`indicators[${index}].title`}
                          type='text'
                          value={props.values.indicators[index].title}
                          onChange={event => props.setFieldValue(`indicators[${index}].title`, event.target.value)}
                          onBlur={() => props.setFieldTouched(`indicators[${index}].title`, true)}
                          placeholderType='alwaysVisible'
                          placeholder='Название индикатора'
                          isDisabled={props.isSubmitting}
                          // @ts-ignore
                          isValid={!(props.errors?.indicators?.[index]?.title && props.touched?.indicators?.[index]?.title)}
                          // @ts-ignore
                          validationError={
                            props.errors?.indicators?.[index]?.title && props.touched?.indicators?.[index]?.title ? props.errors?.indicators?.[index]?.title : undefined
                          }
                          size='small'
                          autoComplete='off'
                        />
                        <TextareaWYSIWYG
                          value={props.values.indicators[index].description || ''}
                          onChange={value => props.setFieldValue(`indicators[${index}].description`, value.replace(/(<([^>]+)>)/gi, '') ? value : '')}
                          onBlur={() => props.setFieldTouched(`indicators[${index}].description`, true)}
                          placeholderType='alwaysVisible'
                          placeholder='Текст индикатора'
                          modulesType='noModules'
                          size='small'
                        />
                      </div>
                      <div className='addRemoveButtons'>
                        {!(props.values.indicators.length === 1 && index === 0) && (
                          <Button type='button' buttonType='button' width='50rem' size='medium' color='white' onClick={() => remove(index)} className='whiteButton'>
                            <img src={icon_closeBlue} alt='icon' className='iconRemove' />
                          </Button>
                        )}
                        {index + 1 === props.values.indicators.length && (
                          <Button type='button' buttonType='button' width='50rem' size='medium' color='blue' onClick={() => push({ title: '', key: '' })}>
                            <img src={icon_plus} alt='icon' className='iconAdd' />
                          </Button>
                        )}
                      </div>
                    </div>
                  ))
                }
              </FieldArray>
            </div>

            <Button
              type='button'
              width='330rem'
              size='medium'
              color='blue'
              text='Сохранить компетенцию'
              loading={props.isSubmitting === true ? true : false}
              className='submitButton'
            />
          </Form>
        )}
      </Formik>

      <div className='addRemoveButtons'>
        <Button
          type='button'
          size='medium'
          width='50rem'
          color='white'
          className='removeComptensionButton'
          onClick={() =>
            mutate({
              competentionID: competensionData!.id,
            })
          }
        />

        {isAddCompenetsionButton && (
          <Button type='button' onClick={() => addCompenetsion(true)} size='medium' width='50rem' color='bliue' className='addComptensionButton'></Button>
        )}
      </div>
    </div>
  );
};
